module.exports = __webpack_public_path__ + "img/fallback-thumbnail.b3c1ae8d.png";